import React from 'react';
import AddUpdateSubjects from '../../components/Subjects/AddUpdateSubjects';

const AddSubjectsPage = () => {
    return (
        <AddUpdateSubjects />
    );
};

export default AddSubjectsPage;